import { render, staticRenderFns } from "./AbnaYousef.vue?vue&type=template&id=8518c052&"
import script from "./AbnaYousef.vue?vue&type=script&lang=js&"
export * from "./AbnaYousef.vue?vue&type=script&lang=js&"
import style0 from "./AbnaYousef.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports